import { CoveoSearchContentType } from '../enums/coveo-search-type.enum';

export const UrlMappings: [string, CoveoSearchContentType][] = [
  ['/faq/', CoveoSearchContentType.FAQ],
  ['/video/', CoveoSearchContentType.Video],
  ['/jabra-glossary', CoveoSearchContentType.JabraGlossary],
  ['/hearing-protection', CoveoSearchContentType.HearingProtection],
  ['/technical-whitepapers', CoveoSearchContentType.TechnicalWhitepapers],
  ['/warranty-terms', CoveoSearchContentType.WarrantyTerms],
  ['/release-notes/', CoveoSearchContentType.ReleaseNotes],
  ['/supportpages/', CoveoSearchContentType.ProductSupportPage],
  ['/business/', CoveoSearchContentType.ProductCatalog],
  ['/bluetooth-headsets/', CoveoSearchContentType.ProductCatalog],
  ['/accessories/', CoveoSearchContentType.ProductCatalog],
];
